"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DocumentGridBreadcrumb = function DocumentGridBreadcrumb(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    clickOnPathCallback = _ref.clickOnPathCallback,
    disabled = _ref.disabled,
    _ref$rootText = _ref.rootText,
    rootText = _ref$rootText === void 0 ? "Project files" : _ref$rootText;
  var getLinkDesign = function getLinkDesign(index) {
    var baseClassName = "btn-default btn-default-style ";
    if (disabled) {
      return baseClassName + "cursor-default";
    }
    if (index + 1 == breadcrumbs.length) {
      return baseClassName + "weight-600 cursor-default";
    }
    return baseClassName + "cursor-pointer font-color-primary";
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-8 align-items-center grid-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      if (!disabled) {
        clickOnPathCallback(breadcrumbs.slice(0, -1));
      }
    },
    disabled: breadcrumbs.length === 0,
    className: getLinkDesign(-1),
    "data-testid": "path-icon-previous",
    style: {
      marginTop: "7px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "ei:arrow-up",
    width: 20,
    height: 20,
    color: "black"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      if (!disabled) {
        clickOnPathCallback([]);
      }
    },
    className: getLinkDesign(-1),
    "data-testid": "path-root"
  }, rootText), breadcrumbs.map(function (path, index) {
    var _path$id, _path$id2, _path$id3, _path$id4, _path$id5;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex gap-8 align-items-center",
      key: "div-".concat((_path$id = path.id) !== null && _path$id !== void 0 ? _path$id : index),
      "data-testid": "div-".concat((_path$id2 = path.id) !== null && _path$id2 !== void 0 ? _path$id2 : index)
    }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "ic:baseline-chevron-right",
      width: 20,
      height: 20,
      color: "#909294",
      key: "icon-".concat((_path$id3 = path.id) !== null && _path$id3 !== void 0 ? _path$id3 : index)
    }), /*#__PURE__*/_react["default"].createElement("button", {
      key: "path-".concat((_path$id4 = path.id) !== null && _path$id4 !== void 0 ? _path$id4 : index),
      onClick: function onClick() {
        if (!disabled) {
          clickOnPathCallback(breadcrumbs.slice(0, index + 1));
        }
      },
      className: getLinkDesign(index),
      "data-testid": "path-".concat((_path$id5 = path.id) !== null && _path$id5 !== void 0 ? _path$id5 : index)
    }, path.name));
  }));
};
var _default = exports["default"] = DocumentGridBreadcrumb;